import { NgModule } from '@angular/core';
import { AuthenticationRoutingModule } from "src/app/applications/authentication/authentication-routing.module";
import { AuthPageContextService } from './modules/admin-auth/services/auth-page-context.service';

@NgModule({
  declarations: [

  ],
  imports: [
    AuthenticationRoutingModule,
  ],
  providers: [AuthPageContextService]
})
export class AuthenticationModule { }
